import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { RooftopMark } from "./RooftopMark";
import { useShortlist } from "../hooks/useShortlist";

const STATE_LABELS = { new: "New", rental: "For Rent", resale: "Resale" };

// One listing card. `listing` is a PublicListingSerializer payload.
export function ListingCard({ listing }) {
  const { has, toggle } = useShortlist();
  const cover = listing.photos?.[0];
  const loc = [listing.locality, listing.city].filter(Boolean).join(", ");
  const meta = [
    listing.configuration,
    listing.bedrooms ? `${listing.bedrooms} Bed` : null,
    listing.area_sqft ? `${listing.area_sqft} sq.ft` : null,
  ]
    .filter(Boolean)
    .join(" · ");
  const saved = has(listing.token);

  return (
    <div className="group relative overflow-hidden rounded-2xl border border-[#DED9CC] bg-[#FBFAF6] transition duration-200 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(20,19,15,0.09)]">
      <button
        type="button"
        onClick={() => toggle(listing.token)}
        aria-label={saved ? "Remove from shortlist" : "Save to shortlist"}
        className="absolute right-2.5 top-2.5 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-[#FBFAF6]/90 shadow-[0_1px_4px_rgba(20,19,15,0.14)] backdrop-blur transition hover:scale-105"
      >
        <Heart
          className="h-[18px] w-[18px]"
          style={{
            fill: saved ? "#B7975A" : "none",
            stroke: saved ? "#B7975A" : "#78746A",
            strokeWidth: 1.6,
          }}
        />
      </button>

      <Link to={`/p/${listing.token}`} className="block">
        {cover ? (
          <img
            src={cover.thumb}
            alt=""
            loading="lazy"
            width={480}
            height={360}
            className="aspect-[4/3] w-full object-cover"
          />
        ) : (
          <div className="flex aspect-[4/3] w-full items-center justify-center bg-[#EDEAE2]">
            <RooftopMark size={40} navy="#C9C3B4" gold="#C9C3B4" />
          </div>
        )}
        <div className="flex flex-1 flex-col gap-2 p-[1.1rem_1.2rem_1.3rem] font-sans">
          <span className="text-[0.68rem] font-semibold uppercase tracking-[0.1em] text-[#B7975A]">
            {STATE_LABELS[listing.offer_state] || listing.offer_state}
            {listing.property_type ? ` · ${cap(listing.property_type)}` : ""}
          </span>
          <h3 className="m-0 text-[1.2rem] font-semibold leading-tight [font-family:'Iowan_Old_Style',Georgia,serif] text-[#14130F]">
            {listing.headline}
          </h3>
          {loc && <div className="text-[0.85rem] text-[#78746A]">{loc}</div>}
          {meta && <div className="text-[0.8rem] text-[#4A473E]">{meta}</div>}
          {listing.price_display && (
            <div className="mt-auto text-[1.1rem] font-bold text-[#1F3766]">{listing.price_display}</div>
          )}
        </div>
      </Link>
    </div>
  );
}

function cap(s) {
  return String(s).charAt(0).toUpperCase() + String(s).slice(1);
}
